import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { getChatSessionDetails } from 'flow/actions/chat-actions';
import { fetchCloudFiles } from 'flow/actions/social-integration-actions';
import Page from 'flow/components/Setting/Page';
import Loading from 'flow/components/ui-components/Loading';
import Tooltip from 'flow/components/ui-components/Tooltip';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

const MessagesDrivePage = () => {
    const { id } = useParams<{ id: ChatSessionKey }>();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const cloudFiles = useAppSelector((state) =>
        state.socialIntegration.getIn(['cloudFiles', id, 'files']),
    );

    useEffect(() => {
        if (cloudFiles) {
            return;
        }
        dispatch(getChatSessionDetails(id));
        dispatch(fetchCloudFiles(id));
    }, [dispatch, id]);

    if (!cloudFiles) {
        return <Loading />;
    }

    return (
        <Page
            header={'Google Drive'}
            onClickBack={() =>
                history.push(
                    generatePath(routes['messages.id.settings'], { id }),
                )
            }
        >
            <div className="grid grid-cols-4 gap-6 pe-2 pt-2">
                {cloudFiles.map((cloudFile) => (
                    <div
                        key={cloudFile.get('thumbnailUrl')}
                        className="group max-h-40 max-w-40 rounded-sm bg-gray-100"
                    >
                        <a
                            href={cloudFile.get('url')}
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            <img
                                src={cloudFile.get('thumbnailUrl')}
                                // Decorative: the link's name comes from the
                                // file name rendered below it.
                                alt=""
                                className="aspect-square max-h-24 w-full rounded-sm object-cover p-2"
                            />

                            <Tooltip label={cloudFile.get('name')}>
                                <div className="flex items-center gap-x-1 truncate p-2 text-sm">
                                    <img
                                        className="rounded-sm object-cover"
                                        src={cloudFile.get('iconUrl')}
                                        alt=""
                                    />

                                    <p className="flex-1 truncate">
                                        {cloudFile.get('name')}
                                    </p>
                                </div>
                            </Tooltip>
                        </a>
                    </div>
                ))}
            </div>
        </Page>
    );
};

export default MessagesDrivePage;
